module.exports = __webpack_public_path__ + "static/media/disfraz-mujer.65f36f8a.jpg";